import React, { useEffect } from "react";
import Navbar from "../components/common/Navbar";
import Footer from "../components/common/Footer";
import styles from "./SalesPolicy.module.css";

const SalesPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={styles.pageContainer}>
      <Navbar />

      <div className={styles.contentWrapper}>
        <h1 className={styles.title}>Sales and Refunds</h1>
        <p className={styles.lastUpdated}>Last updated: January 4, 2026</p>

        <div className={styles.section}>
          <p>
            Thank you for shopping at Dukamo Coffee. We take pride in the
            quality of our beans and want you to have the best brewing
            experience possible.
          </p>
        </div>

        <div className={styles.section}>
          <h2>1. Coffee Returns</h2>
          <p>
            Because coffee is a perishable food product, we generally do not
            accept returns on roasted coffee beans once they have been opened or
            if the order was delivered more than 7 days ago.
          </p>
          <p>
            However, if there was an error with your order, or if the coffee
            arrived damaged, please contact us immediately at{" "}
            <strong>support@dukamocoffee.com</strong> so we can make it right.
          </p>
        </div>

        <div className={styles.section}>
          <h2>2. Merchandise & Equipment</h2>
          <p>
            For non-coffee items (such as brewing equipment, mugs, or apparel),
            we accept returns within 14 days of purchase. Items must be:
          </p>
          <ul>
            <li>Unused and in original packaging.</li>
            <li>Accompanied by a receipt or proof of purchase.</li>
          </ul>
        </div>

        <div className={styles.section}>
          <h2>3. Refunds (if applicable)</h2>
          <p>
            Once your return is received and inspected, we will notify you of
            the approval or rejection of your refund. If approved, your refund
            will be processed and a credit will automatically be applied to your
            original method of payment (e.g., SantimPay or Bank Transfer) within
            5-10 business days.
          </p>
        </div>

        <div className={styles.section}>
          <h2>4. Shipping Costs</h2>
          <p>
            Shipping costs are non-refundable. If you receive a refund, the cost
            of return shipping may be deducted from your refund unless the
            return is due to our error (e.g., wrong item sent).
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default SalesPolicy;
